module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Deploy Unryo","content":"This wizard will help you deploy Unryo on your infrastructure using one of the following methods:","point1":"Docker Compose on a Linux server","point2":"VMware vApp on vSphere","point3":"Kubernetes using a Helm chart"}}')
  delete Component.options._Ctor
}
